




























import { Component, Vue } from 'vue-property-decorator';
import Title from '@/components/Title.vue';
import BusinessReport from '@/components/reports/MonthlyBusinessReport.vue';
import ReportDate from '@/components/reports/MonthlyReportDate.vue';
import LevelMixin from '@/mixins/monthlyBusinessReport.mixin';

@Component({
  components: { 
    Title, 
    BusinessReport, 
    ReportDate 
  },
  mixins: [LevelMixin]
})
export default class MBReport extends Vue {}
